// @flow
import styled from "styled-components";
import { colors } from "./colors";

export const RoundedRectangleWithShadow = styled.div`
  border-radius: 3px;
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03);
  background-color: ${colors.white};
`;
